type RegisterClickParams = {
  brandName: string;
  brandSlug: string;
  registerUrl: string;
  source: 'home_card' | 'brand_page' | 'floating_promo';
};

type LoginClickParams = {
  brandName: string;
  brandSlug: string;
  loginUrl: string;
  source: 'brand_page';
};

export function trackRegisterClick({
  brandName,
  brandSlug,
  registerUrl,
  source,
}: RegisterClickParams) {
  window.gtag?.('event', 'register_click', {
    brand_name: brandName,
    brand_slug: brandSlug,
    register_url: registerUrl,
    source,
  });
}

export function trackLoginClick({
  brandName,
  brandSlug,
  loginUrl,
  source,
}: LoginClickParams) {
  window.gtag?.('event', 'login_click', {
    brand_name: brandName,
    brand_slug: brandSlug,
    login_url: loginUrl,
    source,
  });
}
